import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ActivityAction } from '@stores/activity/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav  from '@components/tabNav';
import ActivityList from '@components/activityList';
import TabFilter  from '@components/tabFilter';

interface ActivityListPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    activity?: ActivityAction;
    activityList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: any
    navCurrentIndex?: any
    navCurrentType?: any
    navClick?: Function
}
interface ActivityListPCState {
    loading: boolean;
    error: any
    pageLoaded: any
}
@inject('app', 'site', 'user', 'activity')
@observer
class ActivityListPCPage extends BasePage<ActivityListPCPageProps, ActivityListPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };
    componentDidMount() {
        super.componentDidMount();
    }
    
    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }

    // 活动列表
    renderActivityList = () => {
        const { activityList, loading, hasMore, onLoadMore } = this.props;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className={styles.activityListBox}>
                    <ActivityList 
                        data={activityList} 
                        loading={loading}
                        hasMore={hasMore}
                        onLoadMore={onLoadMore}
                        emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    ></ActivityList>
                </div>
            </div>
        )
    }

    render() {
        let { navList, navCurrentIndex, navClick } = this.props;

        return (<div className={styles.wrapper}>
            <div className={styles.activityContent}>
                <div className={styles.navBox}>
                    <TabNav navList={navList} currentIndex={navCurrentIndex} navClick={(item:any, index:any) => this.handleNavClick(item, index)}></TabNav>
                </div>
                {this.renderActivityList()}
                
            </div>
            
            
            
        </div>)
    }
}

export default withRouter(ActivityListPCPage);
